import React from "react";
import styled from "@emotion/styled";
import gql from "graphql-tag";
import { navigate } from "@reach/router";
import { useStoreAppValue } from "@hooks";
import { Box, Flex, Text, TextUppercase, TouchableOpacity, BulkShopFlag } from "@atoms";
import { ImageCircle } from "@molecules";
import { theme } from "@styles";
import { constants } from "@services";
import { LinkType } from "@types";
import { LinkBlockFeaturedFragment } from "./__generated__/LinkBlockFeaturedFragment";
// import { LinkBlockPromoLabel } from "../LinkBlockPromoLabel";

// == Types ================================================================
// export enum LinkType {
//   BRAND = "BRAND",
//   DEPARTMENT = "DEPARTMENT",
//   EMPYR = "EMPYR",
//   GIFTCARDOFFER = "GIFTCARDOFFER",
//   PRODUCT = "PRODUCT",
// }
interface IProps {
  link: LinkBlockFeaturedFragment;
}

// == Constants ============================================================
const FRAGMENTS = {
  fields: gql`
    fragment LinkBlockFeaturedFragment on Link {
      id
      type
      giftcardType
      isBulkShop
      name
      image
      logoImage
      giveSentence
      terms
      promoLabel
      promoDescription
      promoSecondaryLabel
      promoEndsAt
    }
  `,
};

// == Component ============================================================
const LinkBlockFeatured = ({ link }: IProps) => {
  const onClick = () => {
    navigate(`?${constants.linkParam}=${link.id}`);
  };

  const { currentUser } = useStoreAppValue();
  const showBulkShop = link.isBulkShop && !!currentUser;

  // TODO: use Image Circle molecule here instead!

  return (
    <TouchableOpacity containerProps={{ style: { width: "100%" } }} onTouch={onClick}>
      <Flex flexDirection="column">
        <Box position="relative">
          {link.isBulkShop && <EBulkShopFlag />}
          {!!link.logoImage && (
            <ImageCircle alt={link.name} border="silver" p={[3, 4]} src={link.logoImage} />
          )}
        </Box>
        {/* {!!link.promoLabel && (
          <LinkBlockPromoLabel label={link.promoLabel} position="absolute" right="0" top="50%" />
        )} */}
        <ETextUppercase fontSize={[0]} pt={2} textAlign="center">
          {link.name}
        </ETextUppercase>
        <Text color={showBulkShop ? theme.colors.purple : theme.colors.black} textAlign="center">
          {link.giveSentence}
        </Text>
        {!!link.promoSecondaryLabel && (
          <EText
            as="div"
            color={showBulkShop ? theme.colors.purple : "primary"}
            dangerouslySetInnerHTML={{
              __html: link.promoSecondaryLabel,
            }}
            fontSize={[0]}
            textAlign="center"
          />
        )}
      </Flex>
    </TouchableOpacity>
  );
};

export default LinkBlockFeatured;

LinkBlockFeatured.fragments = FRAGMENTS;
// == Styles ===============================================================

const EText = styled(Text)`
  font-size: ${(props) => props.theme.fontSizes[0]}px;
  * {
    font-size: ${(props) => props.theme.fontSizes[0]}px;
  }
`;

const ETextUppercase = styled(TextUppercase)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const EBulkShopFlag = styled(BulkShopFlag)`
  position: absolute;
  top: 30px;
  right: 5px;
  height: 45px;
  width: 20px;
`;
